"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const controlIsLegacy_1 = __importDefault(require("../../shared/controlIsLegacy"));
const addUpdatedControlsToFlattedControls = (updatedControls, flattedControls) => updatedControls.reduce((flattedAccum, updatedControl) => {
    if (!(0, controlIsLegacy_1.default)(updatedControl)) {
        throw new Error('Control is not legacy');
    }
    const controlOriginalInfo = flattedAccum[updatedControl.id];
    if (!controlOriginalInfo) {
        throw new Error(`No original info found for control ${updatedControl.id}`);
    }
    const newControlInfo = Object.assign(Object.assign({}, controlOriginalInfo), { control: updatedControl });
    return Object.assign(Object.assign({}, flattedAccum), { [updatedControl.id]: newControlInfo });
}, flattedControls);
exports.default = addUpdatedControlsToFlattedControls;
